import { Injectable } from "@angular/core";
import { Action } from "../../../section/master/model/action";
import { Patient, PatientMedicalHistory } from "../model/patient";
import { Appointment } from "../../appointment/model/appointment";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { HttpClientService } from "../../../shared/service/http/http-client.service";
import { CookiesService } from "../../../shared/service/cookies/cookies.service";
import { Subject } from "rxjs/Subject";
@Injectable()
export class PatientService {
  http: HttpClientService;
  cookie: CookiesService;
  objAction: Action;
  data: Patient;
  medicalData: PatientMedicalHistory;
  profilePic: any[];
  appointmentData: Appointment[];
  private text = new Subject<Appointment[]>();
  text$ = this.text.asObservable();
  constructor(http: HttpClientService, cook: CookiesService) {
    this.http = http;
    this.cookie = cook;
    this.objAction = new Action(this.http, this.cookie);
  }
  savePatient(): Observable<Patient> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Patient/CreatePatient";
    return this.objAction.save();
  }
  getPatientForSearch(filter: string, text: string): Observable<Patient[]> {
    this.objAction.path =
      "api/Patient/GetPatients?filter=" + filter + "&text=" + text;
    return this.objAction.get();
  }
  getFiles(): Observable<unknown> {
    this.objAction.path = "api/Users/ExportUser";
    return this.objAction.getFile();
  }

  getPatients(): Observable<Patient[]> {
    this.objAction.path = "api/Patient/GetPatient";
    return this.objAction.get();
  }
  getPatientDetail(PatientId: number): Observable<Patient[]> {
    this.objAction.path = "api/Patient/GetPatientDetail?id=" + PatientId;
    return this.objAction.get();
  }
  updatePatient(): Observable<Patient> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path = "api/Patient/UpdatePatient";
    return this.objAction.update();
  }
  deletePatient(usr: Patient): Observable<Patient> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/Patient/DeletePatient?strPatientId=" + usr.PatientId;
    return this.objAction.delete();
  }
  createPatientMedicalHistory(): Observable<PatientMedicalHistory> {
    this.objAction.header = null;
    this.objAction.data = this.medicalData;
    this.objAction.path = "api/Patient/CreatePatientMedicalHistory";
    return this.objAction.save();
  }
  savePatientProfile(): Observable<Patient> {
    this.objAction.path = "api/Patient/UpdatePatientProfilePic";
    this.objAction.data = this.data;
    this.objAction.files = this.profilePic;
    return this.objAction.saveDataWithFiles();
  }
  getPatientMedicalHistory(
    patientId: number
  ): Observable<PatientMedicalHistory[]> {
    this.objAction.path =
      "api/Patient/GetPatientMedicalHistory?PatientId=" + patientId;
    return this.objAction.get();
  }

  deletePatientMedicalHistory(
    medicalH: PatientMedicalHistory
  ): Observable<Patient> {
    this.objAction.header = null;
    this.objAction.data = this.data;
    this.objAction.path =
      "api/Patient/DeletePatientMedicalHistory?strPatientId=" +
      medicalH.PatientId +
      "&strMedicalHistoryId=" +
      medicalH.MedicalHistoryId;
    return this.objAction.delete();
  }

  getPatientAppointment(patientId: number): Observable<Appointment[]> {
    this.objAction.path =
      "api/Patient/GetAppointmentByPatientId?PatientId=" + patientId;
    return this.objAction.get();
  }

  publishText(textToPublish: Appointment[]) {
    this.text.next(textToPublish);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/service/patient-service.service.ts